module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_7.4a14adda.png";